import React from "react";
import { defaultData, Props } from "./types";
import UnsplashCredit from "./UnsplashCredit";
import { buildLink, ensurePool, getPoolCursor, getPoolImage, getPoolSize, savePoolCursor } from "./api";

const UnsplashSettings: React.FC<Props> = ({ data = defaultData, loader, setData }) => {
  const [forceKey, forceUpdate] = React.useReducer((x) => x + 1, 0);
  const [poolReady, setPoolReady] = React.useState(false);

  React.useEffect(() => {
    if (data.timeout === Number.MAX_SAFE_INTEGER) {
      setData({
        ...data,
        paused: true,
        timeout: defaultData.timeout,
      });
    }
  }, []);

  // Bootstrap pool
  React.useEffect(() => {
    loader.push();
    ensurePool(data).finally(() => {
      setPoolReady(true);
      loader.pop();
    });
  }, []);

  const cursor = getPoolCursor();
  const item = getPoolImage(cursor);
  const poolSize = getPoolSize();

  const changeCursor = React.useCallback((delta: number) => {
    const size = getPoolSize();
    if (size === 0) return;
    const next = (cursor + delta + size) % size;
    savePoolCursor(next);
    forceUpdate();
  }, [cursor]);

  const goNext = React.useCallback(() => {
    changeCursor(1);
  }, [changeCursor]);

  const goPrev = React.useCallback(() => {
    changeCursor(-1);
  }, [changeCursor]);

  const handlePause = () => {
    setData({
      ...data,
      paused: !data.paused,
    });
  };

  return (
    <div className="UnsplashSettings">
      <label>
        <span style={{ float: "right" }}>
          {item ? (
            <UnsplashCredit
              credit={item.credit}
              source={item.source}
              sourceLink={item.sourceLink}
              paused={data.paused ?? false}
              onPause={handlePause}
              onPrev={goPrev}
              onNext={goNext}
              hideInfo={true}
              hideControls={false}
            />
          ) : null}
        </span>
        Show a new photo
        <select
          value={data.timeout}
          onChange={(event) =>
            setData({ ...data, timeout: Number(event.target.value) })
          }
        >
          <option value="0">Every new tab</option>
          <option value="300">Every 5 minutes</option>
          <option value="900">Every 15 minutes</option>
          <option value="3600">Every hour</option>
          <option value="86400">Every day</option>
          <option value="604800">Every week</option>
        </select>
      </label>
    </div>
  );
};

export default UnsplashSettings;